import { lazy, Suspense } from "react";
import { Navigate } from "react-router-dom";
import LoadingFeedback from "@/components/shared/loading/LoadingFeedback";

const Defaults = lazy(() => import("@/features/hiringDefault/generalDefault/pages/Defaults"));
const Configuration = lazy(() => import("@/features/company/configuration/pages/Configuration"));
const ListsOptions = lazy(() => import("@/features/formAndTemplates/listsOptions/pages/ListsOptions"));
const ReferenceFormGeneration = lazy(
  () => import("@/features/formAndTemplates/referenceForm/pages/ReferenceFormGeneration"),
);
const Templates = lazy(() => import("@/features/formAndTemplates/templates/pages/Templates"));
const JobDescriptionTemplateForm = lazy(
  () => import("@/features/formAndTemplates/templates/pages/JobDescriptionTemplateForm"),
);
const EvaluationFormTemplateForm = lazy(
  () => import("@/features/formAndTemplates/templates/pages/EvaluationFormTemplateForm"),
);
const EmailTemplateForm = lazy(
  () => import("@/features/formAndTemplates/templates/pages/EmailTemplateForm"),
);
const OfferLetterTemplateForm = lazy(
  () => import("@/features/formAndTemplates/templates/pages/OfferLetterTemplateForm"),
);

export const settingsRoute = [
  {
    path: "/settings",
    children: [
      {
        index: true,
        element: <Navigate to="defaults" replace />,
      },
      {
        path: "defaults",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <Defaults />
          </Suspense>
        ),
      },
       {
        path: "configuration",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <Configuration />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "/forms-templates",
    children: [
      {
        index: true,
        element: <Navigate to="lists-options" replace />,
      },
      {
        path: "lists-options",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <ListsOptions />
          </Suspense>
        ),
      },
      {
        path: "reference-form-generation",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <ReferenceFormGeneration />
          </Suspense>
        ),
      },
      {
        path: "templates",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <Templates />
          </Suspense>
        ),
      },
      {
        path: "templates/job-description/new",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <JobDescriptionTemplateForm />
          </Suspense>
        ),
      },
      {
        path: "templates/job-description/:templateId",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <JobDescriptionTemplateForm />
          </Suspense>
        ),
      },
      {
        path: "templates/evaluation-form/new",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <EvaluationFormTemplateForm />
          </Suspense>
        ),
      },
      {
        path: "templates/evaluation-form/:templateId",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <EvaluationFormTemplateForm />
          </Suspense>
        ),
      },
      {
        path: "templates/email/new",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <EmailTemplateForm />
          </Suspense>
        ),
      },
      {
        path: "templates/email/:templateId",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <EmailTemplateForm />
          </Suspense>
        ),
      },
      {
        path: "templates/offer-letter/new",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <OfferLetterTemplateForm />
          </Suspense>
        ),
      },
      {
        path: "templates/offer-letter/:templateId",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <OfferLetterTemplateForm />
          </Suspense>
        ),
      },
    ],
  },
];
